/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import ReducerIndex from 'qwc2/reducers/index';
import sidebarReducer from '../reducers/sidebar';
ReducerIndex.register("sidebar", sidebarReducer);

export const REGISTER_SIDEWINDOW = 'REGISTER_SIDEWINDOW';
export const UNREGISTER_SIDEWINDOW = 'UNREGISTER_SIDEWINDOW';
export const SET_SIDEBAR_WIDTH = 'SET_SIDEBAR_WIDTH';
export const SIDEBAR_MAXIMIZE = 'SIDEBAR_MAXIMIZE';

export function registerSideWindow(windowId) {
    return {
        type: REGISTER_SIDEWINDOW,
        windowId
    };
}

export function unregisterSideWindow(windowId) {
    return {
        type: UNREGISTER_SIDEWINDOW,
        windowId
    };
}

export function sidebarMaximize(windowId) {
    return {
        type: SIDEBAR_MAXIMIZE,
        windowId
    };
}

export function setSidebarWidth(width) {
    return {
        type: SET_SIDEBAR_WIDTH,
        width
    };
}
